import Repository from "../Repository";

const Create = "createCategory";
const getAll = "getAllCategory"
const getAllList = "getAllCategoryList"
const UPDATE_CATEGORY='edit'
export default {
  createCategory(payload) {
    return Repository.post(transformRoute(Create),payload);
  },
  getAllCategory(payload) {
    return Repository.post(transformRoute(getAll),payload);
  },
  getAllCategoryList(payload) {
    return Repository.post(transformRoute(getAllList),payload);
  },
  UpdateCategory(payload) {
    return Repository.post(transformRoute(UPDATE_CATEGORY),payload);
  },
};

const transformRoute = (route) => {
  return `eLearning/elearncategory/${route}`;
};
